import { Navigate, generatePath } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { BLOG_SPORT_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams';

const Page = () => {
  const { slug } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generatePath(BLOG_SPORT_SLUG, {
        sport: 'mlb',
        slug,
      })}
    />
  );
};
export default Page;
